import React, { FunctionComponent } from "react";
import styles from "../llm-summary.module.scss";
import LLMSummarySidebarLoader from "./LLMSummarySidebarLoader";
import LLMSummaryContent from "./LLMSummaryContent";
import { LLMSummary } from "../@types/LLMSummary";

type LLMSummarySidebarContentProps = {
  summaryIsLoading?: boolean;
  shouldShowError?: boolean;
  shouldShowSummary?: boolean;
  summary?: LLMSummary["summary"];
  isProcessing?: boolean;
};

const LLMSummarySidebarContent: FunctionComponent<
  LLMSummarySidebarContentProps
> = ({
  summary,
  summaryIsLoading,
  shouldShowError,
  shouldShowSummary,
  isProcessing
}) => {
  const showLoading = summaryIsLoading && !isProcessing;
  return (
    <div className={styles.llm_summary_panel_content}>
      {showLoading && <LLMSummarySidebarLoader />}
      {shouldShowError && !showLoading && (
        <div>
          An error occurred while generating the summary. Please try again.
        </div>
      )}
      {shouldShowSummary && !showLoading && (
        <LLMSummaryContent summary={summary} isProcessing={isProcessing} />
      )}
    </div>
  );
};

export default LLMSummarySidebarContent;
